import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import CollectionsSection from "./components/CollectionsSection";
import ExploreSection from "./components/ExploreSection";
import CreatorsSection from "./components/CreatorsSection";
import TagsSection from "./components/TagsSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");
  const [activeTag, setActiveTag] = useState("全部");

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onPickTag={setActiveTag} />
        <RankingSection />
        <CollectionsSection />
        <ExploreSection
          query={query}
          onQueryChange={setQuery}
          activeTag={activeTag}
          onTagChange={setActiveTag}
        />
        <CreatorsSection />
        <TagsSection activeTag={activeTag} onPickTag={setActiveTag} />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}